import { render, staticRenderFns } from "./PaymentMethodCards.vue?vue&type=template&id=cd96472e&"
import script from "./PaymentMethodCards.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports